import styled from "styled-components"
const BodyWrapper = styled.div`
  width: calc(100% - 90px);
  word-wrap: break-word;
`
export default BodyWrapper
